import { EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../types/requestForm';
import { createFields } from './utils/createFields';
import { createValidation } from './utils/createValidation';
import { SEND_FEEDBACK_BUTTON_TEXT } from '../../../constants/requestForm/buttonText';
var FIELDS = [EFormFieldsNames.Name, EFormFieldsNames.Phone, EFormFieldsNames.Email, EFormFieldsNames.Message, EFormFieldsNames.Files, EFormFieldsNames.PrivacyPolicyAccepted];
export var COMMON_FORM_STEP = {
  code: EStepCodes.CommonForm,
  question: {
    code: EQuestionCodes.CommonForm,
    title: '',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: SEND_FEEDBACK_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [],
    nextStepCode: null
  }]
};